export enum ProgressTrackerSubStepStatus {
  COMPLETED = 'completed',
  CURRENT = 'current',
  ACCESSIBLE = 'accessible',
  UPCOMING = 'upcoming',
}
